<div class="relative flex flex-col h-full">

  <!-- Header -->
  <!--
  <app-header location="reports"></app-header>
  -->

  <!-- Header area with mobile menu button - conditionally visible -->
  <div class="bg-gray-50 dark:bg-secondary-800 rounded-xl m-3 lg:m-6 lg:mb-0">

    <div class="flex justify-end items-center px-6 py-3 h-20 p-6">

      <!-- Mobile menu button - only shown on mobile -->
      <button type="button"
              *ngIf="!isDesktop"
              class="absolute top-[1.8rem] left-8 p-2 rounded-md text-secondary focus:outline-none"
              (click)="toggleMobileSidebar()"
              aria-label="Open sidebar menu">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      <h1 class="text-lg font-semibold text-secondary dark:text-primary-100 absolute left-1/2 transform -translate-x-1/2">{{ 'create_new_report' | translate }}</h1>

      <!-- Dark Mode Toggle -->
      <app-dark-mode-toggle [mode]="'dashboard'" class="rotate-90 relative left-[0.5rem]"></app-dark-mode-toggle>

    </div>

    <div class="mb-6">

      <!-- Search Person -->
      <app-search-person #personSearch [componentLocation]="'reports'" (dropdownVisibilityChanged)="onDropdownVisibility($event)"></app-search-person>

    </div>

  </div>


  <!-- Spacer that pushes main content to bottom -->
  <div class="flex-1"></div>

  <main class="w-full pb-2 md:pb-0">

    <div class="bg-white dark:bg-indigo-custom w-full h-fit relative">

      <!-- Add a positioned overlay that only appears when showOverlay is true.
           It swallows clicks while the person-search dropdown is open, so clicking it
           must dismiss that dropdown — otherwise the list stays unclickable for as long
           as there is text in the search box. -->
      <div
        [class.opacity-0]="!showOverlay"
        [class.opacity-100]="showOverlay"
        class="absolute inset-0 bg-white dark:bg-transparent bg-opacity-25 backdrop-blur-sm z-10
           transition-opacity duration-300 ease-in-out
           pointer-events-none"
        [class.pointer-events-auto]="showOverlay"
        (click)="dismissPersonSearch()"
      ></div>

      <!-- My reports -->
      <div class="mx-auto max-w-2xl lg:max-w-none flex justify-between items-center w-full px-4 sm:px-6 py-3 sm:py-3">
        <div class="md:flex md:justify-between items-center w-full">
          <h2 *ngIf="this.archivedReports == false" class="text-lg text-secondary dark:text-white font-semibold mb-3 md:mb-0">
            {{ 'my_reports' | translate }}</h2>
          <h2 *ngIf="this.archivedReports == true" class="text-lg text-secondary dark:text-white font-semibold mb-3 md:mb-0">
            {{ 'my_archived_reports' | translate }}</h2>
          <div class="flex items-center">

            <!-- Search -->
            <div class="mr-3">
              <div class="relative rounded-md">
                <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 text-secondary">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                  </svg>
                </div>
                <input type="text" name="search_report" id="search_report" [(ngModel)]="searchQuery" (keyup.enter)="searchReport()" autocomplete="off" class="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 dark:text-white ring-1 ring-inset ring-gray-100 dark:ring-[#3b4377] placeholder:text-secondary/50 placeholder:font-poppins placeholder:tracking-wide focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6" placeholder="Search in my reports">
              </div>
            </div>

            <!-- Search Button -->
            <button type="button" (click)="searchReport()" class="btn bg-gray-50 dark:bg-primary-200 text-secondary text-sm hover:opacity-90 mr-3">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
              </svg>
            </button>

            <!-- Refresh -->
            <button type="button" (click)="refreshReports()"
              class="btn bg-gray-50 dark:bg-primary-200 text-secondary text-sm hover:opacity-90">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
              </svg>
            </button>

            <button *ngIf="this.archivedReports==false"
              class=" relative btn bg-gray-50 dark:bg-primary-200 text-secondary text-sm hover:opacity-90 ml-6"
              (click)="viewArchivedReports()" (mouseover)="showArchivedSearchesTooltip = true"
              (mouseleave)="showArchivedSearchesTooltip = false"
              matTooltip="Show archived reports" matTooltipPosition="above" matTooltipClass="custom-tooltip"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" />
              </svg>

              <!--
              <div
                [ngClass]="{'opacity-100 scale-130': showArchivedSearchesTooltip,'opacity-0 scale-95 pointer-events-none': !showArchivedSearchesTooltip}"
                class="absolute text-center top-full mt-2 left-1/2 -translate-x-1/2 px-2 py-1 text-xs  text-secondary dark:text-[#bcc3ff]  bg-gray-50 dark:bg-secondary rounded shadow-lg transition duration-300 ease-in-out">
                Show archived reports
              </div>
              -->
            </button>
            <button *ngIf="this.archivedReports==true" (click)="refreshReports()"
              class="relative btn bg-gray-50 dark:bg-primary-200 text-secondary text-sm hover:opacity-90 ml-6"
              (mouseover)="showGoBackToSearchesTooltip = true" (mouseleave)="showGoBackToSearchesTooltip = false"
              matTooltip="Show unarchived reports" matTooltipPosition="above" matTooltipClass="custom-tooltip"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                class="h-5 w-5">
                <path fill-rule="evenodd"
                  d="M9.53 2.47a.75.75 0 0 1 0 1.06L4.81 8.25H15a6.75 6.75 0 0 1 0 13.5h-3a.75.75 0 0 1 0-1.5h3a5.25 5.25 0 1 0 0-10.5H4.81l4.72 4.72a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0Z"
                  clip-rule="evenodd" />
              </svg>

              <!--
              <div
                [ngClass]="{'opacity-100 scale-130': showGoBackToSearchesTooltip,'opacity-0 scale-95 pointer-events-none': !showGoBackToSearchesTooltip}"
                class="absolute text-center top-full mt-2 left-1/2 -translate-x-1/2 px-2 py-1 text-xs  text-secondary dark:text-[#bcc3ff]  bg-gray-50 dark:bg-secondary rounded shadow-lg transition duration-300 ease-in-out">
                Go back
              </div>
              -->
            </button>


          </div>

        </div>

      </div>
      <!-- / My dashboard -->

      <div>
        <app-reports-filter
          [exporting]="exporting"
          [selectedCount]="selectedCount"
          [sort]="currentSort"
          [dateRange]="currentDateRange"
          (filtersChanged)="onFiltersChanged($event)"
          (exportClicked)="exportReports()"
          (sortChanged)="onSortChanged($event)"
          (dateRangeChanged)="onDateRangeChanged($event)">
        </app-reports-filter>
      </div>

      <!-- List -->
      <div class="border-t border-b border-gray-100 dark:border-[#3b4377]">

        <!-- Select-all bar (export selection) -->
        <div *ngIf="!loading && hasReports" class="flex items-center justify-between px-4 sm:px-6 py-2 border-b border-gray-100 dark:border-[#3b4377]">
          <label class="flex items-center gap-3 cursor-pointer select-none">
            <input
              type="checkbox"
              class="h-4 w-4 rounded border-gray-300 dark:border-[#3b4377] text-blue-600 focus:ring-blue-500 cursor-pointer"
              [checked]="areAllOnPageSelected()"
              [indeterminate]="isSomeOnPageSelected()"
              (change)="toggleSelectAllOnPage($event)"
              aria-label="Select all reports on this page">
            <span class="text-sm text-secondary dark:text-[#bcc3ff]">{{ 'select_all' | translate }}</span>
          </label>

          <div class="flex items-center gap-4" *ngIf="selectedCount > 0">
            <span class="text-sm text-secondary dark:text-[#bcc3ff]">{{ selectedCount }} {{ selectedCount === 1 ? 'report' : 'reports' }} selected</span>
            <button type="button" (click)="clearSelection()" class="text-sm text-blue-600 hover:opacity-80">Clear</button>
          </div>
        </div>

        <!-- Loading -->
        <div *ngIf="loading" class="flex justify-around items-center h-full" [style.height.px]="windowHeight">
          <svg class="animate-spin h-6 w-6 text-blue-royal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>

        <!-- old code for height: h-[calc(100vh-330px)] (28.04.2024) -->
        <ul *ngIf="!loading" role="list" id="scrollable-list" class="divide-y divide-gray-100 dark:divide-[#3b4377] dark:border-[#3b4377] overflow-y-auto custom-scroll" [style.height.px]="windowHeight">
          <!-- *ngFor="let report of filteredList; index as i;" -->
          <li *ngFor="let report of filteredList$ | async; index as i" class="relative flex justify-between items-center md:gap-x-6 px-4 py-3 hover:bg-gray-50 dark:bg-indigo-custom/25 sm:px-6 cursor-pointer">
            <!-- Stretched link: a real <a href> covering the row so left-click navigates in-app while
                 Cmd/Ctrl/middle-click and "Open in new tab" work. Checkbox + action buttons sit above it (z-10).
                 z-[1] (not z-0) is required: any `relative` element inside the row content paints on top of a
                 z-0 sibling that precedes it in the DOM, which left dead spots on the row (the country/title
                 line, the "gathering data" pulse) where clicks hit nothing. -->
            <a [routerLink]="['/report', report.id]" class="absolute inset-0 z-[1]" [attr.aria-label]="'Open report: ' + (report?.name ?? '')"></a>
            <!-- Export selection checkbox (always visible, unchecked by default) -->
            <div class="relative z-10 flex items-center pr-3 sm:pr-4 flex-none" (click)="$event.stopPropagation()">
              <input
                type="checkbox"
                class="h-4 w-4 rounded border-gray-300 dark:border-[#3b4377] text-blue-600 focus:ring-blue-500 cursor-pointer"
                [checked]="isReportSelected(report.id)"
                (change)="toggleReportSelection(report.id, $event)"
                [attr.aria-label]="'Select report ' + (report?.name ?? '')">
            </div>
            <div class="w-full grid grid-cols-12 gap-3 md:gap-6">
              <!-- User -->
              <div class="col-span-12 lg:col-span-6  max-w-[40rem]">

                <div class="bg-transparent flex items-center gap-x-4 md:p-3 md:pl-0 rounded-md">

                  <!-- Conditionally show image or "no img" placeholder -->
                  <ng-container *ngIf="!imageErrors[report.id]; else noImageTemplate">
                    <img class="h-10 w-10 md:h-12 md:w-12 flex-none rounded-full bg-gray-50"
                         [src]="(report?.picture == null || report?.picture == '[]') ? 'https://ui-avatars.com/api/?background=FFA500&color=fff&rounded=true&name='+report.name+'&format=svg&size=128' : report?.picture"
                         (error)="onImageError(report.id)"
                         alt="avatar">
                  </ng-container>

                  <!-- Placeholder div if the image fails to load -->
                  <ng-template #noImageTemplate>
                    <img class="h-10 w-10 md:h-12 md:w-12 flex-none" src="https://ui-avatars.com/api/?background=FFA500&color=fff&rounded=true&name={{report.name}}&format=svg&size=128">
                  </ng-template>

                  <div class="min-w-0 flex-auto">
                    <p class="text-sm font-semibold leading-6 text-secondary-900 dark:text-white">
                      <span class="flex items-center">
                        {{ report?.name ?? '' }}

                        <!-- Shared indicator -->
                        <div *ngIf="report.is_shared" class="ml-2"
                             [matTooltip]="'Shared by ' + (report.shared_by?.name || 'Unknown')"
                             matTooltipPosition="above"
                             matTooltipClass="violet-500-tooltip">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4 text-violet-500">
                            <path d="M13 4.5a2.5 2.5 0 1 1 .702 1.737L6.97 9.604a2.518 2.518 0 0 1 0 .792l6.733 3.367a2.5 2.5 0 1 1-.671 1.341l-6.733-3.367a2.5 2.5 0 1 1 0-3.475l6.733-3.366A2.52 2.52 0 0 1 13 4.5Z" />
                          </svg>
                        </div>

                        <!-- relative z-[2] keeps this above the stretched link so the tooltip
                             is still hoverable; the dot itself stops being clickable, which
                             is a fair trade for an 8px target. -->
                        <div *ngIf="report.search_status_id !== 3" class="relative z-[2] ml-3" matTooltip="Gathering data" matTooltipPosition="right" matTooltipClass="violet-500-tooltip">
                          <app-pulse-loading [status]="'loading'" [size]="'size-2'"></app-pulse-loading>
                        </div>
                      </span>
                    </p>
                    <p class="md:mt-1 flex text-xs leading-5">
                      <span class="text-gray-500 dark:text-[#bcc3ff] relative" *ngIf="report?.country">  {{ report?.country }} / {{ report?.title ?? ''}}</span>
                      <span class="text-gray-500 dark:text-[#bcc3ff] relative" *ngIf="!report?.country">-</span>
                    </p>

                  </div>

                </div>

              </div>
              <!-- / User -->

              <!-- Company -->
              <div *ngIf="report.company" class="col-span-12 lg:col-span-6">

                <div class="flex items-center w-full gap-6">

                  <div class="bg-violet-50/50 dark:bg-secondary-900 flex gap-x-4 p-3 rounded-md max-w-[35rem] w-full">

                    <!-- Company Logo -->
                    <img
                      class="h-10 w-10 md:h-12 md:w-12 flex-none rounded-md bg-gray-50"
                      [src]="(report.company.logo_url !== '[]') ? report.company.logo_url : 'https://ui-avatars.com/api/?background=FFA500&color=fff&rounded=true&name='+report.company.name+'&format=svg&size=128'"
                      (error)="onCompanyImageError($event)"
                      alt="Company Logo"
                    />

                    <!-- Company Details -->
                    <div class="min-w-0 flex-auto">
                      <p class="text-sm font-semibold leading-6 text-secondary-900 dark:text-white">
                        {{ report.company?.name | slice:0:40 }}{{ report.company?.name?.length > 40 ? '...' : '' }}

                        <span
                          [ngClass]="{
                          'bg-icp-low': report.company.icp_score <= 35,
                          'bg-icp-medium': report.company.icp_score > 35 && report.company.icp_score <= 65,
                          'bg-icp-high': report.company.icp_score > 65
                        }"
                          class="text-sm font-semibold text-white rounded-md py-0.5 px-3 ml-2"
                          matTooltip="ICP Score"
                        >
                        {{ report.company.icp_score ?? 'N/A' }}
                      </span>
                      </p>
                      <p class="md:mt-1 text-xs leading-5 text-gray-500 dark:text-[#bcc3ff]">
                        {{ report.company.city ?? 'Unknown City' }},
                        {{ report.company.country ?? 'Unknown Country' }}
                      </p>
                    </div>

                  </div>

                  <!-- Workspace -->
                  <div class="bg-violet-500 shadow shadow-violet-200 min-w-[48px] w-[48px] min-h-[48px] h-[48px] flex-shrink-0 rounded-lg text-lg flex items-center justify-center"
                       [class.invisible]="report.workspace?.is_default"
                       [matTooltip]="report.workspace?.name || 'Default Workspace'"
                       matTooltipPosition="above"
                       matTooltipClass="violet-500-tooltip">
                    <span class="text-white text-sm font-semibold">{{ report.workspace?.name_acronym || 'N/A' }}</span>
                  </div>

                </div>

              </div>
              <!-- / Company -->
            </div>

            <!-- No z-10 here: only the action buttons need to sit above the stretched link.
                 Lifting the whole column made the date and the chevron dead zones. -->
            <div class="col-span-2 flex shrink-0 items-center gap-x-4">
              <div class="hidden sm:flex sm:flex-col sm:items-end w-[8rem]">
                <p class="text-sm leading-6 text-secondary dark:text-[#bcc3ff]">{{ report?.created_at_human ?? '' }}</p>
              </div>

              <button class="hidden md:inline-block relative z-10 hover:opacity-90" [ngClass]=" report.is_archived === true ? 'hidden' : '' "
                (click)="promptArchive(report.id, report.name, $event)" (mouseover)="showTooltip[i] = true" (mouseleave)="showTooltip[i] = false"
                matTooltip="Archive report" matTooltipPosition="above" matTooltipClass="custom-tooltip"
              >

                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6 flex-none text-secondary dark:text-white">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" />
                </svg>

                <!--
                <div [ngClass]="{'opacity-100 scale-130': showTooltip[i] ,'opacity-0 scale-95 pointer-events-none': !showTooltip[i]}"
                  class="absolute text-center top-full mt-2 left-1/2 -translate-x-1/2 px-2 py-1 text-xs text-secondary dark:text-[#bcc3ff]  bg-gray-50 dark:bg-secondary rounded shadow-lg transition duration-300 ease-in-out">
                  Archive report
                </div>
                -->
              </button>

              <button class="relative z-10 inline-block hover:opacity-90" [ngClass]=" report.is_archived === false ? 'hidden' : '' "
                (click)="restoreSearch(report.id,$event)" (mouseover)="showTooltip[i] = true" (mouseleave)="showTooltip[i] = false"
                matTooltip="Restore report" matTooltipPosition="above" matTooltipClass="custom-tooltip"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-5 w-5 text-secondary dark:text-white group-hover:opacity-90">
                  <path fill-rule="evenodd" d="M9.53 2.47a.75.75 0 0 1 0 1.06L4.81 8.25H15a6.75 6.75 0 0 1 0 13.5h-3a.75.75 0 0 1 0-1.5h3a5.25 5.25 0 1 0 0-10.5H4.81l4.72 4.72a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0Z" clip-rule="evenodd" />
                </svg>

                <!--
                <div [ngClass]="{'opacity-100 scale-130': showTooltip[i] ,'opacity-0 scale-95 pointer-events-none': !showTooltip[i]}"
                  class="absolute text-center top-full mt-2 left-1/2 -translate-x-1/2 px-2 py-1 text-xs text-secondary dark:text-[#bcc3ff]  bg-gray-50 dark:bg-secondary rounded shadow-lg transition duration-300 ease-in-out">
                  Restore report
                </div>
                -->
              </button>

              <svg class="hidden md:block h-6 w-6 flex-none text-secondary dark:text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd" />
              </svg>

            </div>
          </li>

          <!-- No reports found -->
          <!-- *ngIf="filteredList.length === 0" -->
          <li *ngIf="(filteredList$ | async)?.length === 0" class="flex justify-around items-center h-full">
            <div class="text-center">
              <p class="text-gray-500 dark:text-primary-200">No reports found.</p>
              <button (click)="refreshReports()" class="text-sm text-indigo-600 hover:opacity-90">Reload reports</button>
            </div>
          </li>
        </ul>

      </div>
      <!-- / List -->

      <!-- Pagination -->
      <div class="flex items-center justify-between bg-white dark:bg-indigo-custom rounded-b-lg px-4 py-3 sm:px-6">
        <app-pagination (perPageChanged)="onPerPageChanged($event)" (pageChanged)="onPageChanged($event)" [pagination]="pagination" class="w-full"></app-pagination>
      </div>

    </div>

  </main>

</div>

<!--
<app-loader *ngIf="loading"></app-loader>
-->

<app-subscription-banner></app-subscription-banner>

<!-- Export confirmation modal -->
<app-report-export-confirm-modal
  [isVisible]="showExportConfirm"
  [selectedCount]="selectedCount"
  [exporting]="exporting"
  (confirmed)="confirmExport()"
  (cancelled)="cancelExport()">
</app-report-export-confirm-modal>

<!-- Archive confirmation modal -->
<app-confirm-modal
  [isVisible]="showArchiveConfirm"
  [title]="'Archive report'"
  [message]="(pendingArchiveName ? ('Archive ' + pendingArchiveName + '?') : 'Archive this report?') + ' You can restore it later from archived reports.'"
  [confirmLabel]="'Archive'"
  [cancelLabel]="'Cancel'"
  [variant]="'warning'"
  (confirmed)="confirmArchive()"
  (cancelled)="cancelArchive()">
</app-confirm-modal>
